export const LOAD_CONTENT = 'hg/omni/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/omni/DL_PAGE_LOADED';

export const loadContent = () => {
	return {
		type: LOAD_CONTENT
	};
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/omni/omniLanding.js
 **/